import React, { useState } from "react";
import CheckBox from "../../../../Components/CheckBox/CheckBox";
import DropDown1 from "../../../../Components/DropDown1/DropDown1";
import "./ChiefDashbord_filters.css";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/colors/purple.css";
import "react-multi-date-picker/styles/backgrounds/bg-dark.css";
import transition from "react-element-popper/animations/transition";
import opacity from "react-element-popper/animations/opacity";

function ChiefDashbord_filters() {
    const optionsList1 = [
        { label: "خرید و فروش", value: "خرید و فروش" },
        { label: "رهن و اجاره", value: "رهن و اجاره" },
    ];
    const optionsList2 = [
        { label: "مسکونی", value: "مسکونی" },
        { label: "اداری و تجاری", value: "اداری و تجاری" },
    ];
    const optionsList3 = [
        { label: "اپارتمان / برج", value: "اپارتمان / برج" },
        { label: "ویلایی / باغ و باغچه", value: "ویلایی / باغ و باغچه" },
        { label: "پنت هاوس", value: "پنت هاوس" },
        { label: "مستغلات", value: "مستغلات" },
        { label: "زمین / کنگی", value: "زمین / کنگی" },
        { label: "سایر", value: "سایر" },
    ];
    const [Datevalue, setDateValue] = useState(null);
    const handleDateChange = (value) => {
        setDateValue(Datevalue);
    };
    return (
        <div className="ChiefDashbord_filters">
            <span className="ChiefDashbord_filtersTitle">فیلتر بر اساس :</span>
            <div className="ChiefDashbord_filtersContainer">
                <DropDown1 title="نوع آگهی" optionsList={optionsList1} />
                <DropDown1 title="نوع کاربری" optionsList={optionsList2} />
                <DropDown1 title="نوع ملک" optionsList={optionsList3} />
            </div>
            <div style={{ backgroundColor: "#ff6348", color: "snow", padding: "6px 32px", borderRadius: "12px", fontSize: "12px" }}>جستجو</div>
        </div>
    );
}

function CustomInput1({ openCalendar, value, handleValueChange }) {
    return <input className="DP_DateInput" onFocus={openCalendar} value={value} onChange={handleValueChange} placeholder="  /     /  " />;
}

export default ChiefDashbord_filters;
